import React, { useMemo } from "react";
import { Image } from "antd";

export function getRandomItem(array: any[], num: number = 1) {
  const result = [] as any[];

  for (let i = 0; i < num; i++) {
    const randomIndex = Math.floor(Math.random() * array.length);
    result.push(array.splice(randomIndex, 1));
  }
  return result.flat();
}

const imageList = [
  "https://photo.8891.com.tw/2024/07/09/1720508836692763.png",
  "https://photo.8891.com.tw/2024/07/09/1720508851147752.png",
  "https://photo.8891.com.tw/2024/07/09/1720508857532982.png",
  "https://photo.8891.com.tw/2024/07/09/1720508862119694.png",
  "https://photo.8891.com.tw/2024/07/09/1720508866861747.png",
  "https://photo.8891.com.tw/2024/07/09/1720508871114821.png",
  "https://photo.8891.com.tw/2024/07/09/1720508875367002.png",
  "https://photo.8891.com.tw/2024/07/09/1720508879564976.png",
  "https://photo.8891.com.tw/2024/07/09/1720508883445149.png",
  "https://photo.8891.com.tw/2024/07/09/1720508883445149.png",
  "https://photo.8891.com.tw/2024/07/09/1720508887290467.png",
  "https://photo.8891.com.tw/2024/07/09/1720508892080771.png",
];

const ScrollImage = () => {
  const list = useMemo(() => {
    return getRandomItem(imageList, 3) as string[];
  }, [imageList]);

  return (
    <div className='w-70 h-26'>
      <div className='flex w-full h-full'>
        {list.map((item, index) => {
          return (
            <div
              className='w-26 h-26 relative inline-block'
              key={item}
              style={{ right: `-${(list.length - 1 - index) * 0.06}rem` }}
            >
              <img className='w-full h-full object-contain' src={item} alt={item} key={item} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ScrollImage;
